import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class PropertyTagsSubscription extends Model {
  [Type] = 'property-tags/subscription' as const;

  @attr('string') declare name: string;
}
